export var PINCODE_LENGTH = 6;
export var NAME_LENGTH = 40;
export var UPIFIELDS = {
  NAME: 'name',
  PINCODE: 'pincode',
  COUNTRY: 'country'
};
export var INDIA_COUNTRY_CODE = 'IN';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UpiOption/types.js
// module id = 662
// module chunks = 11